const charitiesStatus = {
    active: 'ACTIVE',
    inactive: 'INACTIVE',
    closed: 'CLOSED',
}

export default charitiesStatus